<template>
  <div v-if="isPopout" class="m-0 p-0 vh-100 overflow-hidden">
    <CandlesHardcoded />
  </div>
  <div v-else class="container-fluid py-7">
    <div class="card">
      <base-header class="pb-6" type="">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 d-inline-block mb-0">Candle Stick Chart</h6>
          </div>
        </div>
        <CandlesHardcoded />
      </base-header>
    </div>
  </div>
</template>
<script>
import CandlesHardcoded from "./Components/CandlesHardcoded.vue";
export default {
  name: "CandleStickChart",
  components: { CandlesHardcoded },
  computed: {
    isPopout() {
      const q = this.$route.query || {};
      return Object.prototype.hasOwnProperty.call(q, "popout");
    },
  },
  mounted() {
    if (this.isPopout) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
  },
  unmounted() {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  },
};
</script>
